namespace TabAurous.Inventory {
    export interface MeltingRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        AutoPosting?: boolean;
        DepartmentId?: number;
        BaseItemTypeId?: number;
        TermsId?: number;
        CurrencyId?: number;
        KaratId?: number;
        MetalColorId?: number;
        ExchRate?: number;
        NetAmount?: number;
        Roundoff?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        Stoneweight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        Purity?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        AddressId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        FinancialYearId?: number;
        UserId?: number;
        RequiredPureWeight?: number;
        RequiredAlloy?: number;
        RequiredAlloyTemp?: number;
        IssuedPureWeight?: number;
        IssuedAlloy?: number;
        ReceivedWeight?: number;
        ReceivableWeight?: number;
        Loss?: number;
        LossPercent?: number;
        ItemDetails?: MeltingItemsRow[];
        ReturnDetails?: MeltingReturnItemsRow[];
        PostingDate?: string;
        IsPosted?: boolean;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        Username?: string;
    }

    export namespace MeltingRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.Melting';
        export const deletePermission = 'Inventory:Melting:Delete';
        export const insertPermission = 'Inventory:Melting:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:Melting:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            AutoPosting = "AutoPosting",
            DepartmentId = "DepartmentId",
            BaseItemTypeId = "BaseItemTypeId",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            Roundoff = "Roundoff",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            Stoneweight = "Stoneweight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            Purity = "Purity",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            AddressId = "AddressId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            RequiredPureWeight = "RequiredPureWeight",
            RequiredAlloy = "RequiredAlloy",
            RequiredAlloyTemp = "RequiredAlloyTemp",
            IssuedPureWeight = "IssuedPureWeight",
            IssuedAlloy = "IssuedAlloy",
            ReceivedWeight = "ReceivedWeight",
            ReceivableWeight = "ReceivableWeight",
            Loss = "Loss",
            LossPercent = "LossPercent",
            ItemDetails = "ItemDetails",
            ReturnDetails = "ReturnDetails",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            Username = "Username"
        }
    }
}
